import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Sofía Martínez', 'Lucía Fernández', 'Camila Rodríguez', 'Martina González', 'Valentina López', 'Agustina Pérez', 'Florencia Gómez', 'Julieta Díaz', 'Micaela Sánchez', 'Carolina Romero'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setBuyer({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 8000);
    // Interval every 30 seconds
    const intervalTimer = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-112">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-6 left-6 right-6 md:right-auto md:w-80 bg-white rounded-xl shadow-2xl border border-stone-100 p-4 z-50 flex flex-col gap-3" data-id="element-113">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-stone-400 hover:text-stone-600" data-id="element-114">
            <X size={16} data-id="element-115" />
          </button>

          <div className="flex flex-col items-start gap-2" data-id="element-116">
            <div className="flex flex-col items-start gap-1" data-id="element-117">
              <CheckCircle2 className="text-green-500 w-6 h-6" data-id="element-118" />
              <p className="text-sm font-bold text-stone-800" data-id="element-119">
                {buyer.name} de {buyer.city}
              </p>
            </div>
            <p className="text-xs text-stone-500" data-id="element-120">
              Acaba de comprar el Sistema Integral...
            </p>
            <p className="text-[10px] text-stone-400 font-medium" data-id="element-121">
              hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}